import usePersistFn from '@/hooks/usePersistFn';
import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import { useSafeState } from 'ahooks';
import { message, Tooltip } from 'aui';
import clsx from 'clsx';
import copy from 'copy-to-clipboard';
import React from 'react';

export type CopyableTextProps = {
  text: string;
  disabled?: boolean;
  content?: React.ReactNode;
  className?: string;
};

export function CopyableText(props: CopyableTextProps) {
  const { text, disabled, className, content } = props;

  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);
  const [tooltip, setTooltip] = useSafeState(clientI18n('copyToClipboard'));
  const timerRef = React.useRef(-1);

  const handleCopy = usePersistFn(() => {
    const result = copy(text);
    let msg;
    if (result) {
      msg = clientI18n('isCopied');
      message.success(msg);
    } else {
      msg = clientI18n('failToCopied');
      message.error(msg);
    }
    setTooltip(msg);

    window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      setTooltip(clientI18n('copyToClipboard'));
    }, 2000);
  });

  if (disabled) {
    return <span>{text}</span>;
  }

  return (
    <Tooltip title={tooltip}>
      <span
        className={clsx('cursor-pointer hover:underline hover:decoration-dashed', className)}
        onClick={handleCopy}
      >
        {content ?? text}
      </span>
    </Tooltip>
  );
}
